import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDrag } from "react-dnd";
import { styled } from "@mui/material/styles";
import { palette } from "styled-theme";
import Avatar from "@mui/material/Avatar";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import { pathOr } from "ramda";

import Tooltip from "@mui/material/Tooltip";

import { ICONS } from "~/constants/materials";
import { MATERIAL_ITEM_TYPE } from "~/constants/dnd-types";

import EventBus from "~/libs/eventBus";

const MaterialIcon = styled(Avatar)`
  width: 60px !important;
  height: 60px !important;
  background-color: ${palette("mbgreen", 0)} !important;
  pointer-events: auto;
  cursor: pointer;
  opacity: ${props => (props.isHovered ? 0.9 : 0.7)};
`;

const ThrashIcon = styled(DeleteIcon)`
  position: absolute !important;
  display: block !important;
  height: 40px !important;
  width: 40px !important;
  top: -25px !important;
  left: 35px !important;
  pointer-events: auto !important;

  &:hover {
    color: red !important;
  }
`;

const Marker = styled("div")(props => {
  if (props.marginal) {
    return {
      cursor: "pointer",
      position: "relative",
      display: "inline-block",
      top: "auto",
      left: "auto"
    };
  }
  return {
    cursor: "pointer",
    position: "absolute",
    display: "block",
    top: `${props.y}px`,
    left: `${props.x}px`
  };
});

function DragDropMaterial({ position, clickHandler, materialType, isEditMode, showModal, _id, _rev, tooltip }) {
  const { x, y, marginal } = position;
  const isPresentationOnly = pathOr(false, ["isPresentationOnly"], position);
  const Icon = ICONS[materialType];

  const [isDeleteDisplayed, setDeleteDisplayed] = useState(false);
  const [{}, dragSource, dragPreview] = useDrag({
    item: {
      type: MATERIAL_ITEM_TYPE,
      _id,
      _rev,
      position
    },
    canDrag: () => isEditMode,
    begin: () => EventBus.dispatch("onDragBegin"),
    end: () => EventBus.dispatch("onDragEnd")
  });

  function showDeleteIcon() {
    setDeleteDisplayed(true);
  }

  function hideDeleteIcon() {
    setDeleteDisplayed(false);
  }

  function showDeleteModal() {
    showModal("DELETE_MATERIAL_POSITION", {
      positionId: position._id
    });
  }

  if (isPresentationOnly) {
    return null;
  }

  return (
    <Marker
      onMouseEnter={showDeleteIcon}
      onMouseLeave={hideDeleteIcon}
      ref={dragSource}
      marginal={marginal}
      x={x}
      y={y}
    >
      <Tooltip title={tooltip}>
        <MaterialIcon
          ref={dragPreview}
          isHovered={isDeleteDisplayed}
          onClick={clickHandler}
          className="panzoomAllowTouch"
        >
          <Icon />
        </MaterialIcon>
      </Tooltip>
      {isDeleteDisplayed && isEditMode && <ThrashIcon onClick={showDeleteModal} className="panzoomAllowTouch" />}
    </Marker>
  );
}

DragDropMaterial.propTypes = {
  position: PropTypes.object,
  clickHandler: PropTypes.func,
  materialType: PropTypes.string,
  isEditMode: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired,
  _id: PropTypes.string,
  _rev: PropTypes.string
};

export default DragDropMaterial;
